import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, DestroyRef, Directive, ElementRef, inject, input, PLATFORM_ID } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent, map, pairwise, throttleTime } from 'rxjs';

enum ScrollDirection {
    Up = 'Up',
    Down = 'Down',
}

@Directive({
    selector: '[reactiveToolbar]',
    standalone: true,
})
export class ReactiveToolbarDirective implements AfterViewInit {
    private readonly hostElement = inject(ElementRef);
    private readonly destroyRef = inject(DestroyRef);
    private readonly platformId = inject(PLATFORM_ID);
    isBrowser = isPlatformBrowser(this.platformId);
    private toolBar = this.hostElement.nativeElement;
    private readonly doc = inject(DOCUMENT);

    root = input<HTMLElement, HTMLElement | string | null>(this.doc.body, { transform: (e) => (typeof e === 'string' ? this.doc.body.querySelector(e) : e) });
    throttleTime = input(150, { transform: (t: number) => (t < 100 ? 100 : t) });
    threshold = input<number>(this.toolBar.clientHeight);
    ngAfterViewInit(): void {
        if (!this.isBrowser) return;
        if (!this.root()) return;
        this._initStyles();
        fromEvent(this.root(), 'scroll')
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                // startWith(this.root().scrollTop),
                map(() => this.root().scrollTop),
                pairwise(),
                throttleTime(this.throttleTime())
            )
            .subscribe(([y1, y2]) => {
                const direction = y2 <= y1 ? ScrollDirection.Up : ScrollDirection.Down;
                if (direction == ScrollDirection.Down && y2 > this.threshold()) {
                    this.show = false;
                } else this.show = direction == ScrollDirection.Up;
            });
    }

    private set show(show: boolean) {
        this.toolBar.style.transform = !show ? 'translateY(-100%)' : 'translateY(0)';
    }

    private _initStyles() {
        this.toolBar.style.transition = 'transform 0.3s ease-in-out';
        this.toolBar.style.position = 'fixed';
        this.toolBar.style.top = '0';
        this.toolBar.style.width = '100%';
        this.toolBar.style.zIndex = '100';
    }
}
